module.exports = __webpack_public_path__ + "static/media/file_download.dcf30203.png";